export default __webpack_public_path__ + "assets/ios-pwa-install-screen.png";